(function () {
    const page = document.querySelector("[data-warksar-page-with-contents]");

    if (!page) {
        return;
    }

    const content = page.querySelector(".gh-content");
    const contents = page.querySelector("[data-warksar-contents]");
    const list = page.querySelector("[data-warksar-page-nav]");

    if (!content || !contents || !list) {
        return;
    }

    const headings = Array.from(content.querySelectorAll("h2, h3")).filter((heading) => {
        return heading.textContent.trim().length > 0;
    });

    if (!headings.length) {
        return;
    }

    const usedIds = new Set();

    Array.from(document.querySelectorAll("[id]"))
        .filter((element) => !headings.includes(element))
        .forEach((element) => usedIds.add(element.id));

    function slugify(value) {
        return value
            .normalize("NFKD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .replace(/&/g, " and ")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "") || "section";
    }

    function ensureHeadingId(heading) {
        const base = heading.id || slugify(heading.textContent.trim());
        let id = base;
        let suffix = 2;

        while (usedIds.has(id)) {
            id = `${base}-${suffix}`;
            suffix += 1;
        }

        heading.id = id;
        usedIds.add(id);

        return id;
    }

    function createItem(heading) {
        const item = document.createElement("li");
        const link = document.createElement("a");

        link.href = `#${ensureHeadingId(heading)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);

        return item;
    }

    let currentSection;

    headings.forEach((heading) => {
        const item = createItem(heading);

        if (heading.tagName === "H2") {
            item.classList.add("is-depth-2");
            list.append(item);
            currentSection = item;
            return;
        }

        item.classList.add("is-depth-3");

        if (!currentSection) {
            list.append(item);
            return;
        }

        let nestedList = currentSection.querySelector(":scope > ol");

        if (!nestedList) {
            nestedList = document.createElement("ol");
            currentSection.append(nestedList);
        }

        nestedList.append(item);
    });

    contents.hidden = false;
}());
